// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ConfigureWith,
    EntLibServiceClient,
    SetPackageName,
} from '@trialcard/shared';
export * from './cardExtV1Api.js';
import { CardExtV1Api } from './cardExtV1Api.js';
export * from './caseV3Api.js';
import { CaseV3Api } from './caseV3Api.js';
export * from './claimV1Api.js';
import { ClaimV1Api } from './claimV1Api.js';
export * from './defaultApi.js';
import { DefaultApi } from './defaultApi.js';
export * from './diagnosisV3Api.js';
import { DiagnosisV3Api } from './diagnosisV3Api.js';
export * from './documentV3Api.js';
import { DocumentV3Api } from './documentV3Api.js';
export * from './edgeApi.js';
import { EdgeApi } from './edgeApi.js';
export * from './edgeAccountApi.js';
import { EdgeAccountApi } from './edgeAccountApi.js';
export * from './edgeAddressApi.js';
import { EdgeAddressApi } from './edgeAddressApi.js';
export * from './edgeAdminApi.js';
import { EdgeAdminApi } from './edgeAdminApi.js';
export * from './edgeAuthenticationApi.js';
import { EdgeAuthenticationApi } from './edgeAuthenticationApi.js';
export * from './edgeBmsApi.js';
import { EdgeBmsApi } from './edgeBmsApi.js';
export * from './edgeCardApi.js';
import { EdgeCardApi } from './edgeCardApi.js';
export * from './edgeCiscoApi.js';
import { EdgeCiscoApi } from './edgeCiscoApi.js';
export * from './edgeClaimApi.js';
import { EdgeClaimApi } from './edgeClaimApi.js';
export * from './edgeClsApi.js';
import { EdgeClsApi } from './edgeClsApi.js';
export * from './edgeCmmApi.js';
import { EdgeCmmApi } from './edgeCmmApi.js';
export * from './edgeCouponApi.js';
import { EdgeCouponApi } from './edgeCouponApi.js';
export * from './edgeDataApi.js';
import { EdgeDataApi } from './edgeDataApi.js';
export * from './edgeDebitCardApi.js';
import { EdgeDebitCardApi } from './edgeDebitCardApi.js';
export * from './edgeDigitalPaymentApi.js';
import { EdgeDigitalPaymentApi } from './edgeDigitalPaymentApi.js';
export * from './edgeDocumentsApi.js';
import { EdgeDocumentsApi } from './edgeDocumentsApi.js';
export * from './edgeEmailApi.js';
import { EdgeEmailApi } from './edgeEmailApi.js';
export * from './edgeEmdApi.js';
import { EdgeEmdApi } from './edgeEmdApi.js';
export * from './edgeEnrollmentApi.js';
import { EdgeEnrollmentApi } from './edgeEnrollmentApi.js';
export * from './edgeFinancialScreeningApi.js';
import { EdgeFinancialScreeningApi } from './edgeFinancialScreeningApi.js';
export * from './edgeGovernmentExclusionApi.js';
import { EdgeGovernmentExclusionApi } from './edgeGovernmentExclusionApi.js';
export * from './edgeHhsApi.js';
import { EdgeHhsApi } from './edgeHhsApi.js';
export * from './edgeHubApi.js';
import { EdgeHubApi } from './edgeHubApi.js';
export * from './edgeIntakeApi.js';
import { EdgeIntakeApi } from './edgeIntakeApi.js';
export * from './edgeMangoApi.js';
import { EdgeMangoApi } from './edgeMangoApi.js';
export * from './edgeMedicalApi.js';
import { EdgeMedicalApi } from './edgeMedicalApi.js';
export * from './edgeNoteApi.js';
import { EdgeNoteApi } from './edgeNoteApi.js';
export * from './edgeNpiApi.js';
import { EdgeNpiApi } from './edgeNpiApi.js';
export * from './edgeOrchestratorApi.js';
import { EdgeOrchestratorApi } from './edgeOrchestratorApi.js';
export * from './edgePaFollowUpApi.js';
import { EdgePaFollowUpApi } from './edgePaFollowUpApi.js';
export * from './edgePatientApi.js';
import { EdgePatientApi } from './edgePatientApi.js';
export * from './edgePatientAccountApi.js';
import { EdgePatientAccountApi } from './edgePatientAccountApi.js';
export * from './edgePatientEnrollmentApi.js';
import { EdgePatientEnrollmentApi } from './edgePatientEnrollmentApi.js';
export * from './edgePayloadStagingApi.js';
import { EdgePayloadStagingApi } from './edgePayloadStagingApi.js';
export * from './edgePayorApi.js';
import { EdgePayorApi } from './edgePayorApi.js';
export * from './edgePharmacyApi.js';
import { EdgePharmacyApi } from './edgePharmacyApi.js';
export * from './edgePharmacyScriptApi.js';
import { EdgePharmacyScriptApi } from './edgePharmacyScriptApi.js';
export * from './edgePlpApi.js';
import { EdgePlpApi } from './edgePlpApi.js';
export * from './edgePolicyReporterApi.js';
import { EdgePolicyReporterApi } from './edgePolicyReporterApi.js';
export * from './edgePorticoApi.js';
import { EdgePorticoApi } from './edgePorticoApi.js';
export * from './edgePrescriptionApi.js';
import { EdgePrescriptionApi } from './edgePrescriptionApi.js';
export * from './edgePriorAuthorizationApi.js';
import { EdgePriorAuthorizationApi } from './edgePriorAuthorizationApi.js';
export * from './edgeProgramApi.js';
import { EdgeProgramApi } from './edgeProgramApi.js';
export * from './edgeRelayApi.js';
import { EdgeRelayApi } from './edgeRelayApi.js';
export * from './edgeSignatureApi.js';
import { EdgeSignatureApi } from './edgeSignatureApi.js';
export * from './edgeSiteApi.js';
import { EdgeSiteApi } from './edgeSiteApi.js';
export * from './edgeSiteAccountApi.js';
import { EdgeSiteAccountApi } from './edgeSiteAccountApi.js';
export * from './edgeSwaggerIgnoreApi.js';
import { EdgeSwaggerIgnoreApi } from './edgeSwaggerIgnoreApi.js';
export * from './edgeTempApi.js';
import { EdgeTempApi } from './edgeTempApi.js';
export * from './edgeTenantApi.js';
import { EdgeTenantApi } from './edgeTenantApi.js';
export * from './edgeTokenApi.js';
import { EdgeTokenApi } from './edgeTokenApi.js';
export * from './edgeTransientApi.js';
import { EdgeTransientApi } from './edgeTransientApi.js';
export * from './emailV1Api.js';
import { EmailV1Api } from './emailV1Api.js';
export * from './enrollmentExtV2Api.js';
import { EnrollmentExtV2Api } from './enrollmentExtV2Api.js';
export * from './enrollmentV1Api.js';
import { EnrollmentV1Api } from './enrollmentV1Api.js';
export * from './escoordV1Api.js';
import { EscoordV1Api } from './escoordV1Api.js';
export * from './intakeV1Api.js';
import { IntakeV1Api } from './intakeV1Api.js';
export * from './locationV1Api.js';
import { LocationV1Api } from './locationV1Api.js';
export * from './notesV2Api.js';
import { NotesV2Api } from './notesV2Api.js';
export * from './patientV3Api.js';
import { PatientV3Api } from './patientV3Api.js';
export * from './payorV4Api.js';
import { PayorV4Api } from './payorV4Api.js';
export * from './payorV4GlobalApi.js';
import { PayorV4GlobalApi } from './payorV4GlobalApi.js';
export * from './pharmacyV2Api.js';
import { PharmacyV2Api } from './pharmacyV2Api.js';
export * from './pharmacyV2GlobalApi.js';
import { PharmacyV2GlobalApi } from './pharmacyV2GlobalApi.js';
export * from './prescriberV3Api.js';
import { PrescriberV3Api } from './prescriberV3Api.js';
export * from './prescriptionV1Api.js';
import { PrescriptionV1Api } from './prescriptionV1Api.js';
export * from './programV2Api.js';
import { ProgramV2Api } from './programV2Api.js';
export * from './siteV2Api.js';
import { SiteV2Api } from './siteV2Api.js';
export * from './siteV3Api.js';
import { SiteV3Api } from './siteV3Api.js';
export * from './surveyV2Api.js';
import { SurveyV2Api } from './surveyV2Api.js';
export * from './surveyV3Api.js';
import { SurveyV3Api } from './surveyV3Api.js';

import { Lazy, Scoped } from 'vue-di';
import { configure } from './configure.js';
export * from './configure.js';

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class ApigatewayApi extends EntLibServiceClient {
    public constructor(
        @Lazy(CardExtV1Api as any) private readonly _cardExtV1: () => CardExtV1Api,
        @Lazy(CaseV3Api as any) private readonly _caseV3: () => CaseV3Api,
        @Lazy(ClaimV1Api as any) private readonly _claimV1: () => ClaimV1Api,
        @Lazy(DefaultApi as any) private readonly _default: () => DefaultApi,
        @Lazy(DiagnosisV3Api as any) private readonly _diagnosisV3: () => DiagnosisV3Api,
        @Lazy(DocumentV3Api as any) private readonly _documentV3: () => DocumentV3Api,
        @Lazy(EdgeApi as any) private readonly _edge: () => EdgeApi,
        @Lazy(EdgeAccountApi as any) private readonly _edgeAccount: () => EdgeAccountApi,
        @Lazy(EdgeAddressApi as any) private readonly _edgeAddress: () => EdgeAddressApi,
        @Lazy(EdgeAdminApi as any) private readonly _edgeAdmin: () => EdgeAdminApi,
        @Lazy(EdgeAuthenticationApi as any) private readonly _edgeAuthentication: () => EdgeAuthenticationApi,
        @Lazy(EdgeBmsApi as any) private readonly _edgeBms: () => EdgeBmsApi,
        @Lazy(EdgeCardApi as any) private readonly _edgeCard: () => EdgeCardApi,
        @Lazy(EdgeCiscoApi as any) private readonly _edgeCisco: () => EdgeCiscoApi,
        @Lazy(EdgeClaimApi as any) private readonly _edgeClaim: () => EdgeClaimApi,
        @Lazy(EdgeClsApi as any) private readonly _edgeCls: () => EdgeClsApi,
        @Lazy(EdgeCmmApi as any) private readonly _edgeCmm: () => EdgeCmmApi,
        @Lazy(EdgeCouponApi as any) private readonly _edgeCoupon: () => EdgeCouponApi,
        @Lazy(EdgeDataApi as any) private readonly _edgeData: () => EdgeDataApi,
        @Lazy(EdgeDebitCardApi as any) private readonly _edgeDebitCard: () => EdgeDebitCardApi,
        @Lazy(EdgeDigitalPaymentApi as any) private readonly _edgeDigitalPayment: () => EdgeDigitalPaymentApi,
        @Lazy(EdgeDocumentsApi as any) private readonly _edgeDocuments: () => EdgeDocumentsApi,
        @Lazy(EdgeEmailApi as any) private readonly _edgeEmail: () => EdgeEmailApi,
        @Lazy(EdgeEmdApi as any) private readonly _edgeEmd: () => EdgeEmdApi,
        @Lazy(EdgeEnrollmentApi as any) private readonly _edgeEnrollment: () => EdgeEnrollmentApi,
        @Lazy(EdgeFinancialScreeningApi as any) private readonly _edgeFinancialScreening: () => EdgeFinancialScreeningApi,
        @Lazy(EdgeGovernmentExclusionApi as any) private readonly _edgeGovernmentExclusion: () => EdgeGovernmentExclusionApi,
        @Lazy(EdgeHhsApi as any) private readonly _edgeHhs: () => EdgeHhsApi,
        @Lazy(EdgeHubApi as any) private readonly _edgeHub: () => EdgeHubApi,
        @Lazy(EdgeIntakeApi as any) private readonly _edgeIntake: () => EdgeIntakeApi,
        @Lazy(EdgeMangoApi as any) private readonly _edgeMango: () => EdgeMangoApi,
        @Lazy(EdgeMedicalApi as any) private readonly _edgeMedical: () => EdgeMedicalApi,
        @Lazy(EdgeNoteApi as any) private readonly _edgeNote: () => EdgeNoteApi,
        @Lazy(EdgeNpiApi as any) private readonly _edgeNpi: () => EdgeNpiApi,
        @Lazy(EdgeOrchestratorApi as any) private readonly _edgeOrchestrator: () => EdgeOrchestratorApi,
        @Lazy(EdgePaFollowUpApi as any) private readonly _edgePaFollowUp: () => EdgePaFollowUpApi,
        @Lazy(EdgePatientApi as any) private readonly _edgePatient: () => EdgePatientApi,
        @Lazy(EdgePatientAccountApi as any) private readonly _edgePatientAccount: () => EdgePatientAccountApi,
        @Lazy(EdgePatientEnrollmentApi as any) private readonly _edgePatientEnrollment: () => EdgePatientEnrollmentApi,
        @Lazy(EdgePayloadStagingApi as any) private readonly _edgePayloadStaging: () => EdgePayloadStagingApi,
        @Lazy(EdgePayorApi as any) private readonly _edgePayor: () => EdgePayorApi,
        @Lazy(EdgePharmacyApi as any) private readonly _edgePharmacy: () => EdgePharmacyApi,
        @Lazy(EdgePharmacyScriptApi as any) private readonly _edgePharmacyScript: () => EdgePharmacyScriptApi,
        @Lazy(EdgePlpApi as any) private readonly _edgePlp: () => EdgePlpApi,
        @Lazy(EdgePolicyReporterApi as any) private readonly _edgePolicyReporter: () => EdgePolicyReporterApi,
        @Lazy(EdgePorticoApi as any) private readonly _edgePortico: () => EdgePorticoApi,
        @Lazy(EdgePrescriptionApi as any) private readonly _edgePrescription: () => EdgePrescriptionApi,
        @Lazy(EdgePriorAuthorizationApi as any) private readonly _edgePriorAuthorization: () => EdgePriorAuthorizationApi,
        @Lazy(EdgeProgramApi as any) private readonly _edgeProgram: () => EdgeProgramApi,
        @Lazy(EdgeRelayApi as any) private readonly _edgeRelay: () => EdgeRelayApi,
        @Lazy(EdgeSignatureApi as any) private readonly _edgeSignature: () => EdgeSignatureApi,
        @Lazy(EdgeSiteApi as any) private readonly _edgeSite: () => EdgeSiteApi,
        @Lazy(EdgeSiteAccountApi as any) private readonly _edgeSiteAccount: () => EdgeSiteAccountApi,
        @Lazy(EdgeSwaggerIgnoreApi as any) private readonly _edgeSwaggerIgnore: () => EdgeSwaggerIgnoreApi,
        @Lazy(EdgeTempApi as any) private readonly _edgeTemp: () => EdgeTempApi,
        @Lazy(EdgeTenantApi as any) private readonly _edgeTenant: () => EdgeTenantApi,
        @Lazy(EdgeTokenApi as any) private readonly _edgeToken: () => EdgeTokenApi,
        @Lazy(EdgeTransientApi as any) private readonly _edgeTransient: () => EdgeTransientApi,
        @Lazy(EmailV1Api as any) private readonly _emailV1: () => EmailV1Api,
        @Lazy(EnrollmentExtV2Api as any) private readonly _enrollmentExtV2: () => EnrollmentExtV2Api,
        @Lazy(EnrollmentV1Api as any) private readonly _enrollmentV1: () => EnrollmentV1Api,
        @Lazy(EscoordV1Api as any) private readonly _escoordV1: () => EscoordV1Api,
        @Lazy(IntakeV1Api as any) private readonly _intakeV1: () => IntakeV1Api,
        @Lazy(LocationV1Api as any) private readonly _locationV1: () => LocationV1Api,
        @Lazy(NotesV2Api as any) private readonly _notesV2: () => NotesV2Api,
        @Lazy(PatientV3Api as any) private readonly _patientV3: () => PatientV3Api,
        @Lazy(PayorV4Api as any) private readonly _payorV4: () => PayorV4Api,
        @Lazy(PayorV4GlobalApi as any) private readonly _payorV4Global: () => PayorV4GlobalApi,
        @Lazy(PharmacyV2Api as any) private readonly _pharmacyV2: () => PharmacyV2Api,
        @Lazy(PharmacyV2GlobalApi as any) private readonly _pharmacyV2Global: () => PharmacyV2GlobalApi,
        @Lazy(PrescriberV3Api as any) private readonly _prescriberV3: () => PrescriberV3Api,
        @Lazy(PrescriptionV1Api as any) private readonly _prescriptionV1: () => PrescriptionV1Api,
        @Lazy(ProgramV2Api as any) private readonly _programV2: () => ProgramV2Api,
        @Lazy(SiteV2Api as any) private readonly _siteV2: () => SiteV2Api,
        @Lazy(SiteV3Api as any) private readonly _siteV3: () => SiteV3Api,
        @Lazy(SurveyV2Api as any) private readonly _surveyV2: () => SurveyV2Api,
        @Lazy(SurveyV3Api as any) private readonly _surveyV3: () => SurveyV3Api,
    ) {
        super();
    }

    public get cardExtV1() { return this._cardExtV1(); }
    public get caseV3() { return this._caseV3(); }
    public get claimV1() { return this._claimV1(); }
    public get default() { return this._default(); }
    public get diagnosisV3() { return this._diagnosisV3(); }
    public get documentV3() { return this._documentV3(); }
    public get edge() { return this._edge(); }
    public get edgeAccount() { return this._edgeAccount(); }
    public get edgeAddress() { return this._edgeAddress(); }
    public get edgeAdmin() { return this._edgeAdmin(); }
    public get edgeAuthentication() { return this._edgeAuthentication(); }
    public get edgeBms() { return this._edgeBms(); }
    public get edgeCard() { return this._edgeCard(); }
    public get edgeCisco() { return this._edgeCisco(); }
    public get edgeClaim() { return this._edgeClaim(); }
    public get edgeCls() { return this._edgeCls(); }
    public get edgeCmm() { return this._edgeCmm(); }
    public get edgeCoupon() { return this._edgeCoupon(); }
    public get edgeData() { return this._edgeData(); }
    public get edgeDebitCard() { return this._edgeDebitCard(); }
    public get edgeDigitalPayment() { return this._edgeDigitalPayment(); }
    public get edgeDocuments() { return this._edgeDocuments(); }
    public get edgeEmail() { return this._edgeEmail(); }
    public get edgeEmd() { return this._edgeEmd(); }
    public get edgeEnrollment() { return this._edgeEnrollment(); }
    public get edgeFinancialScreening() { return this._edgeFinancialScreening(); }
    public get edgeGovernmentExclusion() { return this._edgeGovernmentExclusion(); }
    public get edgeHhs() { return this._edgeHhs(); }
    public get edgeHub() { return this._edgeHub(); }
    public get edgeIntake() { return this._edgeIntake(); }
    public get edgeMango() { return this._edgeMango(); }
    public get edgeMedical() { return this._edgeMedical(); }
    public get edgeNote() { return this._edgeNote(); }
    public get edgeNpi() { return this._edgeNpi(); }
    public get edgeOrchestrator() { return this._edgeOrchestrator(); }
    public get edgePaFollowUp() { return this._edgePaFollowUp(); }
    public get edgePatient() { return this._edgePatient(); }
    public get edgePatientAccount() { return this._edgePatientAccount(); }
    public get edgePatientEnrollment() { return this._edgePatientEnrollment(); }
    public get edgePayloadStaging() { return this._edgePayloadStaging(); }
    public get edgePayor() { return this._edgePayor(); }
    public get edgePharmacy() { return this._edgePharmacy(); }
    public get edgePharmacyScript() { return this._edgePharmacyScript(); }
    public get edgePlp() { return this._edgePlp(); }
    public get edgePolicyReporter() { return this._edgePolicyReporter(); }
    public get edgePortico() { return this._edgePortico(); }
    public get edgePrescription() { return this._edgePrescription(); }
    public get edgePriorAuthorization() { return this._edgePriorAuthorization(); }
    public get edgeProgram() { return this._edgeProgram(); }
    public get edgeRelay() { return this._edgeRelay(); }
    public get edgeSignature() { return this._edgeSignature(); }
    public get edgeSite() { return this._edgeSite(); }
    public get edgeSiteAccount() { return this._edgeSiteAccount(); }
    public get edgeSwaggerIgnore() { return this._edgeSwaggerIgnore(); }
    public get edgeTemp() { return this._edgeTemp(); }
    public get edgeTenant() { return this._edgeTenant(); }
    public get edgeToken() { return this._edgeToken(); }
    public get edgeTransient() { return this._edgeTransient(); }
    public get emailV1() { return this._emailV1(); }
    public get enrollmentExtV2() { return this._enrollmentExtV2(); }
    public get enrollmentV1() { return this._enrollmentV1(); }
    public get escoordV1() { return this._escoordV1(); }
    public get intakeV1() { return this._intakeV1(); }
    public get locationV1() { return this._locationV1(); }
    public get notesV2() { return this._notesV2(); }
    public get patientV3() { return this._patientV3(); }
    public get payorV4() { return this._payorV4(); }
    public get payorV4Global() { return this._payorV4Global(); }
    public get pharmacyV2() { return this._pharmacyV2(); }
    public get pharmacyV2Global() { return this._pharmacyV2Global(); }
    public get prescriberV3() { return this._prescriberV3(); }
    public get prescriptionV1() { return this._prescriptionV1(); }
    public get programV2() { return this._programV2(); }
    public get siteV2() { return this._siteV2(); }
    public get siteV3() { return this._siteV3(); }
    public get surveyV2() { return this._surveyV2(); }
    public get surveyV3() { return this._surveyV3(); }
}

